var map = {
	"./AB Bank.png": 996,
	"./BIDC.png": 997,
	"./Bắc Á Bank.png": 998,
	"./HD Bank.png": 999,
	"./IVB Bank.png": 1000,
	"./Kiên Long Bank.png": 1001,
	"./MB Bank.png": 1002,
	"./MSB.png": 1003,
	"./NAM Á Bank.png": 1004,
	"./OCB Bank.png": 1005,
	"./OCEAN Bank.png": 1006,
	"./Sài Gòn Bank.png": 1007,
	"./TECHCOMBANK.png": 1008,
	"./TPBANK.png": 1009,
	"./VCBBANK.png": 1010,
	"./VIB Bank.png": 1011,
	"./VIETABANK.png": 1012,
	"./VietTinBank.png": 1013,
	"./agribank.png": 1014,
	"./baovietbank.png": 1015,
	"./bidv.png": 1016,
	"./eximbank.png": 1017,
	"./qr-acb.png": 1018,
	"./qr-shb.png": 1019,
	"./scb.png": 1020,
	"./vietbank.png": 1021,
	"./vietcombank.png": 1022,
	"./vpbank.png": 1023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 606;